import {useStore} from 'vuex'
import PriceToggle from '../PriceToggle/PriceToggle.vue'
import startSearch from '../../foundation/js/startSearch'
import { computed, onMounted } from 'vue'

export default {
    name: "ServiceMenu",
    components:{
        PriceToggle
    },
    setup(){
        const store = useStore()
        const userLoggedIn = computed(()=>store.state.main.user_logged_in_status)
        const closeQuickSearch = startSearch.bind(null,null)
        const cartCount = computed(()=>{
            const count = store.state.ecom.items_count
            return count ? `(${count})` : ''
        })
        const openMobileMenu = function(){
            closeQuickSearch(true)
            const toggleState = store.state.main.mobile_drawer_component ? '' : 'SiteNavigationMobile'
            store.commit('main/set_mobile_drawer_component',toggleState)
        }

        onMounted(()=>{
            if(userLoggedIn.value) store.dispatch('ecom/getCartQuantity')
        })

        return {
            openMobileMenu,
            startSearch,
            cartCount
        }
    }
}